import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import marked from 'marked';
import cx from 'classnames';
import get from 'utils/get';
import slugify from 'utils/slugify';
import addLinkAndBoldToTopicWord from 'utils/addLinkAndBoldToTopicWord';

import withBreakpoint from 'lib/withBreakpoint';
import withLines from 'lib/withLines';
import SocialLinks from 'components/SocialLinks';

const BlockText = React.memo(
  ({
    block,
    breakpointData,
    setRef,
    hasSocialLinks,
    backgroundLineKeywords
  }) => {
    const fields = get(block, 'fields', {});
    const title = get(fields, 'title', '');
    const textStyle = slugify(get(fields, 'textStyle', 'Medium'));
    const textPositionX = get(fields, 'textPositionX', 0);
    const textPositionY = get(fields, 'textPositionY', 0);
    const paddingTop = slugify(get(fields, 'paddingTop', 'Large'));
    const paddingBottom = slugify(get(fields, 'paddingBottom', 'Large'));
    const showBlockTitle = get(fields, 'showBlockTitle', false);
    const text = get(fields, 'text', '');

    const renderer = new marked.Renderer();
    renderer.strong = (text, level) => {
      return `<strong class='connected-with-lines nowrap'>${text}</strong>`;
    };

    renderer.codespan = (text, level) => {
      return `<a href='explore' class='linked-to-explore'>${text}</a>`;
    };

    return (
      <div
        ref={setRef}
        className={cx(
          `BlockText relative px2_5 padding-top-${paddingTop} padding-bottom-${paddingBottom} block-width mxauto flex justify-center`,
          { guideline: showBlockTitle }
        )}
      >
        {showBlockTitle ? (
          <p className="block-title absolute r0 t0">{title}</p>
        ) : null}
        <div className="relative">
          <div
            style={
              !breakpointData.breakpointIsSmall
                ? {
                    transform: `translate(${textPositionX}%, ${textPositionY}%)`
                  }
                : {}
            }
            className={cx(
              'BlockText__text-container markdown-text z-line-text relative',
              {
                'BlockText__text-container--small story-description-small':
                  textStyle === 'small',
                'story-description': textStyle !== 'small'
              }
            )}
            dangerouslySetInnerHTML={{
              __html: marked(
                addLinkAndBoldToTopicWord(text, backgroundLineKeywords),
                { renderer }
              )
            }}
          />
          {hasSocialLinks ? (
            <div className="BlockText__social-links absolute none lg:block">
              <SocialLinks />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
);

BlockText.propTypes = {
  block: PropTypes.shape({
    fields: PropTypes.shape({
      text: PropTypes.string,
      textPositionX: PropTypes.number,
      textPositionY: PropTypes.number,
      textStyle: PropTypes.string,
      paddingBottom: PropTypes.string,
      paddingTop: PropTypes.string,
      showBlockTitle: PropTypes.bool
    })
  }),
  currentBreakpoint: PropTypes.string
};

BlockText.defaultProps = {
  block: {
    fields: {
      text: '',
      textPositionX: 0,
      textPositionY: 0,
      textStyle: 'Medium',
      paddingTop: 'Large',
      paddingBottom: 'Large',
      showBlockTitle: false
    }
  },
  currentBreakpoint: 'small'
};

export default withBreakpoint(withLines(BlockText));
